import React from 'react';
import type { Account, User } from '@axiom/validation';
import {
  Paragraph,
  Card,
  CardFooter,
  CardHeader,
  CardSection,
  SmallHeader,
} from '@axiom/ui';

import { StartEngagementButton } from '../StartEngagementButton/StartEngagementButton';

export type ClientEngagementStartNewProjectProps = {
  account: Account;
  user: User;
};

export const ClientEngagementStartNewProject = ({
  account,
  user,
}: ClientEngagementStartNewProjectProps) => {
  return (
    <Card name="NEW_ENGAGEMENT_CARD" stretched className="with-borders">
      <CardHeader>
        <SmallHeader name="NEW_ENGAGEMENT_HEADER">
          Need more support
        </SmallHeader>
      </CardHeader>
      <CardSection divider>
        <Paragraph>
          Axiom has world-class legal talent with experience spanning all types
          of legal work, practice areas, and industries. If you have more legal
          work coming up, start a new engagement now and let Axiom help you get
          ahead of it.
        </Paragraph>
      </CardSection>
      <CardFooter>
        <StartEngagementButton
          name="NEW_ENGAGEMENT_NAVIGATE_BUTTON"
          account={account}
          user={user}
          pattern="primary"
          variation="outline"
        >
          Start an Engagement
        </StartEngagementButton>
      </CardFooter>
    </Card>
  );
};
